import { dataLoader } from './dataLoader.js';
import { dataCache } from './dataCache.js';
import * as turf from '@turf/turf';

const NODE_DATA_URLS = ['/data/nodes.geojson', '/data/nodes.json'];

class NodeStore {
  constructor() {
    this.nodes = null;
  }

  async init() {
    if (this.nodes) return;

    const cached = dataCache.get('nodes');
    if (cached) {
      this.nodes = cached;
    } else {
      this.nodes = await dataLoader.load(NODE_DATA_URLS);
      dataCache.set('nodes', this.nodes);
    }
  }

  findNearestNode(lngLat) {
    const point = turf.point(lngLat);
    const nodePoints = turf.featureCollection(
      this.nodes.features.map((f) =>
        turf.point(f.geometry.coordinates, f.properties)
      )
    );

    const nearest = turf.nearestPoint(point, nodePoints);
    const distance = turf.distance(point, nearest, { units: 'meters' });

    return {
      node: nearest.properties,
      distance: Math.round(distance)
    };
  }

  findNodesInRange(lngLat) {
    const point = turf.point(lngLat);
    const results = [];

    for (const feature of this.nodes.features) {
      const nodePoint = turf.point(feature.geometry.coordinates);
      const distance = turf.distance(point, nodePoint, { units: 'meters' });
      const radius = feature.properties.influenceRadiusMeters || 0;

      if (distance <= radius) {
        results.push({
          node: feature.properties,
          distance: Math.round(distance),
          inRange: true
        });
      }
    }

    return results.sort((a, b) => a.distance - b.distance);
  }

  getAllNodes() {
    return this.nodes;
  }
}

export const nodeStore = new NodeStore();
